import * as React from 'react';
import cx from 'classnames';

/**
 * The Bar component. It acts as a container that houses multiple actionable components within.
 */
export interface IBarProps {
  /** Passed down classname. */
  className?: string;
  /** Space avoiding below */
  includeSpaceBelow?: boolean;
  /** Make the Button small. */
  isSmall?: boolean;
  /** Button has a white outline and text, the background color is dependant on parent */
  isReverse?: boolean;
  /** Content specified as children. */
  children?: React.ReactNode;
}

export const Bar: React.FC<IBarProps> = ({
  className,
  children,
  includeSpaceBelow = false,
  isSmall = false,
  isReverse = false,
}) => {
  const combinedClass = cx({
    'panda-bar': true,
    'panda-bar--small': isSmall,
    'panda-bar--normal': !isSmall,
    'panda-bar--space-below-small': includeSpaceBelow && isSmall,
    'panda-bar--space-below-large': includeSpaceBelow && !isSmall,
    // Reverse style
    'panda-bar-normal': !isReverse,
    'panda-bar-reverse': isReverse,
    // Custom classname
    [className || '']: true,
  });

  return <div className={combinedClass}>{children}</div>;
};
